import React, { useState, useEffect } from "react";
import axios from "axios";
import { Spin } from "antd";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

  const API_BASE = process.env.REACT_APP_API_BASE;

function Furniture() {
  const [furniture, setFurniture] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch furniture from backend
  useEffect(() => {
    const fetchFurniture = async () => {
      try {
        const res = await axios.get(`${API_BASE}/service/readAllService`);
        const data = res?.data?.data?.services || [];

        // Filter category → Furniture
        const furnitureItems = data.filter(
          (item) =>
            item.category?.toLowerCase() === "furniture" ||
            item.category?.toLowerCase() === "furnitures"
        );

        setFurniture(furnitureItems);
        setFiltered(furnitureItems);
      } catch (err) {
        console.error("Failed to load furniture:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchFurniture();
  }, []);

  return (
    <div className="max-w-7xl mx-auto mt-10 mb-16 px-4">
      <h2
        className="text-3xl md:text-4xl font-bold text-center mb-10"
        style={{ color: "#1A8F5A", fontFamily: "var(--font-heading)" }}
      >
        Furniture Collection
      </h2>

      {loading ? (
        <div className="flex justify-center items-center py-20">
          <Spin size="large" />
        </div>
      ) : filtered.length === 0 ? (
        <p className="text-center text-gray-500">No furniture items available.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
          {filtered.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              viewport={{ once: true }}
              className="rounded-xl overflow-hidden border cursor-pointer"
              style={{
                background: "#FFFFFF",
                border: "1px solid #E5E7EB",
                boxShadow: "0 8px 20px rgba(18,24,30,0.04)",
              }}
            >
              <Link to={`/furniture/${item._id}`}>
                <img
                  src={item.image || "https://source.unsplash.com/400x300/?furniture,interior"}
                  alt={item.name}
                  className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
                />
              </Link>

              <div className="p-4">
                <h3
                  className="text-lg font-semibold line-clamp-1"
                  style={{ color: "#1A1A1A", fontFamily: "var(--font-heading)" }}
                >
                  {item.name}
                </h3>

                <p className="text-sm text-gray-500 line-clamp-2">
                  {item.description}
                </p>

                <p className="font-semibold mt-2" style={{ color: "#1A8F5A" }}>
                  {item.price ? `£${item.price}` : "Price on request"}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Furniture;
